module.exports = __webpack_public_path__ + "media/images/emblems/Meinier-coat_of_arms-29578629a4f746425fde16b0a69475a2.svg";